import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=ced801e2&scoped=true&"
import script from "./DialogConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirm.vue?vue&type=style&index=0&id=ced801e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced801e2",
  null
  
)

export default component.exports